import React, { useEffect } from 'react';

const WhatsappTerms = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="container mx-auto px-4 py-8">
			<section className="pt-8 pt-md-11 pb-8 pb-md-14">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-12 col-md">
							<h1 className="display-4 mb-2">
								Finvu's WhatsApp-SDK-based AA Customer Interface Terms &amp;
								Conditions
							</h1>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<hr className="my-6 my-md-8" />
						</div>
					</div>

					<div className="row">
						<div className="col-12 col-md-11">
							{/* Preamble */}
							<p className="text-gray-800">
								These WhatsApp-SDK-based AA Customer Interface T&Cs govern the
								use by a customer (<b>"User"</b>) of the WhatsApp-SDK-based AA
								Customer Interface made available by Finvu Account Aggregator (
								<b>"Finvu"</b>), in its capacity as a licensed NBFC–Account
								Aggregator. The Finvu WhatsApp-SDK is an AA customer interface
								that can be used by customers for account discovery, account
								linking, and consent management, similar to Finvu's web or
								mobile apps. It can also serve as an effective channel for
								communication and interaction.
							</p>

							<p className="text-gray-800">
								These WhatsApp-SDK-based AA Customer Interface T&Cs are
								supplemental to, and shall be read in conjunction with, the
								Finvu Account Aggregator Terms of Service available at{' '}
								<a href="https://finvu.in/terms" target="_blank" rel="noreferrer">
									https://finvu.in/terms
								</a>{' '}
								(<b>"Finvu's Terms of Service"</b>). Nothing in these
								WhatsApp-SDK-based AA Customer Interface T&Cs shall limit or
								derogate from Finvu's Terms of Service. In the event of any
								inconsistency, the following order of precedence shall apply
								solely in relation to Finvu's WhatsApp-SDK-based AA Customer
								Interface: (i) applicable law and regulatory directions; (ii)
								Finvu's Terms of Service; and (iii) these WhatsApp-SDK-based AA
								Customer Interface T&Cs.
							</p>

							<p className="text-gray-800">
								Capitalised terms used but not defined herein shall have the
								meanings ascribed to them in Finvu's Terms of Service.
							</p>

							{/* Section 1 */}
							<h3 className="mb-5 mt-6">
								1. Scope and Relationship with Finvu's Terms of Service
							</h3>

							<p className="text-gray-800">
								These WhatsApp-SDK-based AA Customer Interface T&Cs apply only
								to the User's interaction with Finvu through WhatsApp (the{' '}
								<b>"WhatsApp Channel"</b>) for the limited purposes of:
							</p>
							<p className="text-gray-800 ml-4">
								(a) discovering and linking financial information provider (FIP)
								accounts, including authentication with FIPs;
							</p>
							<p className="text-gray-800 ml-4">
								(b) approving or rejecting consent requests initiated by
								financial information users (FIUs) through the AA;
							</p>
							<p className="text-gray-800 ml-4">
								(c) receiving consent request status notifications, account
								linking status updates, and other communications related to
								consent artefacts and FI data requests; and
							</p>
							<p className="text-gray-800 ml-4">
								(d) managing and revoking existing consent artefacts,
							</p>
							<p className="text-gray-800">
								all strictly within the regulatory framework applicable to
								Account Aggregators in India, including the ReBIT NBFC-AA API
								Specification and RBI Master Direction on NBFC-AA.
							</p>

							<p className="text-gray-800">
								All general provisions governing:
							</p>
							<p className="text-gray-800 ml-4">
								(a) eligibility to use the Finvu AA services;
							</p>
							<p className="text-gray-800 ml-4">
								(b) the creation, structure, scope, validity, storage, and use
								of the consent artefact;
							</p>
							<p className="text-gray-800 ml-4">
								(c) rights and obligations of Finvu, Financial Information
								Providers (<b>"FIPs"</b>) and Financial Information Users (
								<b>"FIUs"</b>);
							</p>
							<p className="text-gray-800 ml-4">
								(d) disclaimers of warranties;
							</p>
							<p className="text-gray-800 ml-4">
								(e) limitation of liability;
							</p>
							<p className="text-gray-800 ml-4">(f) indemnity;</p>
							<p className="text-gray-800 ml-4">
								(g) intellectual property;
							</p>
							<p className="text-gray-800 ml-4">
								(h) governing law and dispute resolution; and
							</p>
							<p className="text-gray-800 ml-4">
								(i) other standard contractual terms,
							</p>
							<p className="text-gray-800">
								are contained in Finvu's Terms of Service and are hereby
								incorporated by reference, <i>mutatis mutandis</i>, and shall
								apply to the WhatsApp Channel as if set out fully herein.
							</p>

							<p className="text-gray-800">
								These WhatsApp-SDK-based AA Customer Interface T&Cs do not, by
								themselves, govern:
							</p>
							<p className="text-gray-800 ml-4">
								(a) the provision of any financial product or service by any
								FIP, FIU, or any other regulated/unregulated third party;
							</p>
							<p className="text-gray-800 ml-4">
								(b) any use of WhatsApp between the User and any person other
								than Finvu;
							</p>
							<p className="text-gray-800 ml-4">
								(c) any channels other than WhatsApp (including Finvu's web
								portals, mobile applications, voice-based agents or any other
								SDKs);
							</p>
							<p className="text-gray-800 ml-4">
								(d) any processing of financial information carried out solely
								between FIPs and FIUs under their respective arrangements.
							</p>

							{/* Section 2 */}
							<h3 className="mb-5 mt-6">
								2. WhatsApp-Specific Definitions
							</h3>

							<p className="text-gray-800">
								For these WhatsApp-SDK-based AA Customer Interface T&Cs only,
								and in addition to the definitions under Finvu's Terms of
								Service:
							</p>
							<p className="text-gray-800">
								<b>"Finvu WhatsApp Number"</b> means the official WhatsApp
								business account number designated to Finvu for the purposes of
								providing the WhatsApp-SDK-based AA Customer Interface.
							</p>
							<p className="text-gray-800">
								<b>"Registered Mobile Number"</b> means the mobile number of
								the User as recorded in Finvu's systems and mapped to the User's
								AA profile under Finvu's Terms of Service.
							</p>
							<p className="text-gray-800">
								<b>"WhatsApp Channel"</b> means the communication channel
								comprising the WhatsApp application and related infrastructure,
								owned and operated by WhatsApp LLC / Meta Platforms, Inc. and/or
								their affiliates, through which Finvu provides the
								WhatsApp-SDK-based AA Customer Interface.
							</p>
							<p className="text-gray-800">
								<b>"WhatsApp Interaction"</b> means any message, instruction,
								response, acknowledgement, or other communication exchanged
								between the User and Finvu via the WhatsApp Channel, including
								messages that redirect the User to Finvu's secure web or mobile
								interfaces.
							</p>

							{/* Section 3 */}
							<h3 className="mb-5 mt-6">
								3. Scope of WhatsApp-SDK-based AA Customer Interface – Covered
								and Excluded Aspects
							</h3>

							<p className="text-gray-800">
								<b>Covered aspects:</b>
							</p>
							<p className="text-gray-800">
								Subject always to Finvu's Terms of Service and applicable law,
								the WhatsApp-SDK-based AA Customer Interface may include any or
								all of the following, as enabled by Finvu from time to time:
							</p>
							<p className="text-gray-800 ml-4">
								(a) outbound notifications and communications, including:
							</p>
							<p className="text-gray-800 ml-5">
								a response message from Finvu, triggered upon a request by the
								User to commence the consent journey on Finvu's WhatsApp
								channel;
							</p>
							<p className="text-gray-800 ml-5">
								a completion message from Finvu upon conclusion of the Consent
								Journey, confirming the outcome (consent request approved or
								rejected), and — in the case of an approved consent request —
								containing: (i) a web URL enabling the User to initiate
								revocation of the consent artefact at any time; and (ii) a CTA
								with an embedded URL redirecting the User to the FIU's
								designated platform or interface;
							</p>
							<p className="text-gray-800 ml-5">
								updates on consent artefact status (for example, consent
								artefact created, active, paused, expired, or revoked);
							</p>
							<p className="text-gray-800 ml-4">
								(b) two-way interactions within the Consent Journey, conducted
								via WhatsApp Flows, where the User may:
							</p>
							<p className="text-gray-800 ml-5">
								discover and link financial accounts held with Financial
								Information Providers (FIPs), including authenticating with FIPs
								as required;
							</p>
							<p className="text-gray-800 ml-5">
								review all consent artefact parameters and explicitly approve or
								reject a consent request presented by Finvu on behalf of an FIU;
								and
							</p>
							<p className="text-gray-800 ml-5">
								submit a request to revoke an existing consent artefact via the
								revocation URL provided in the completion message, which Finvu
								shall process subject to authentication and validation;
							</p>
							<p className="text-gray-800 ml-4">
								and such other account linking, consent artefact management, or
								support interactions as Finvu may enable for Users from time to
								time.
							</p>

							<p className="text-gray-800 mt-4">
								<b>Excluded aspects:</b>
							</p>
							<p className="text-gray-800">
								For clarity, the WhatsApp-SDK-based AA Customer Interface does
								NOT cover and shall not be used by the User for:
							</p>
							<p className="text-gray-800 ml-4">
								(a) the transmission or display of any financial information
								(FI), account statements, transaction-level data, or other
								Financial Information as defined under the ReBIT NBFC-AA API
								Specification, between a FIP and FIU — such FI data flows occur
								exclusively through the AA's secure backend infrastructure, and
								not through the WhatsApp channel;
							</p>
							<p className="text-gray-800 ml-4">
								(b) the direct modification of an existing consent artefact —
								any change in consent artefact parameters requires revocation of
								the existing consent artefact and creation of a new consent
								artefact through the prescribed consent request flow; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) any product onboarding, loan disbursal, investment
								execution, or other financial transaction outside the AA
								regulatory framework.
							</p>
							<p className="text-gray-800">
								To the extent that Finvu, for regulatory, operational, or
								security reasons, restricts or disables any of the features
								envisaged under this clause, the User acknowledges that such
								restriction shall not affect the validity or enforceability of
								any consent artefact created through the prescribed ReBIT consent
								request workflow in accordance with Finvu's Terms of Service.
							</p>

							{/* Section 4 */}
							<h3 className="mb-5 mt-6">
								4. User Eligibility, Registration and Opt-In for WhatsApp
								Channel
							</h3>

							<p className="text-gray-800">
								The WhatsApp Channel is available only to Users who:
							</p>
							<p className="text-gray-800 ml-4">
								(a) have a valid Virtual User Address (VUA) / Registered Mobile
								Number mapped to their AA profile with Finvu; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) have an active WhatsApp account on the same Registered
								Mobile Number, subject to WhatsApp's own terms of service and
								acceptable use policies.
							</p>

							<p className="text-gray-800">
								The Consent Journey via the WhatsApp-SDK-based AA Customer
								Interface is initiated when the FIU sends a business-initiated
								message to the User via the FIU's WhatsApp Business Account,
								containing a CTA that redirects the User to Finvu's WhatsApp
								Business Account (WABA).
							</p>

							<p className="text-gray-800">
								By (i) clicking such CTA and sending a request to Finvu to
								commence the consent journey; (ii) accepting Finvu's
								WhatsApp-SDK-based AA Customer Interface Terms &amp; Conditions
								and Privacy Policy presented via hyperlink on the first screen
								of the WhatsApp Flow, the User is deemed to have:
							</p>
							<p className="text-gray-800 ml-4">
								(a) expressly opted in to use the WhatsApp-SDK-based AA Customer
								Interface for the purposes of account discovery, account
								linking, and consent artefact management in relation to Finvu's
								AA services; and
							</p>
							<p className="text-gray-800 ml-4">
								(b) read, understood, and accepted these WhatsApp-SDK-based AA
								Customer Interface T&Cs, in addition to Finvu's Terms of
								Service.
							</p>

							<p className="text-gray-800">
								Before commencing each Consent Journey via the
								WhatsApp-SDK-based AA Customer Interface, Finvu shall
								authenticate the User by way of a one-time password (OTP)
								delivered to the User's Registered Mobile Number. The User must
								complete this authentication step before any account discovery,
								account linking, or consent management interaction is processed
								by Finvu.
							</p>

							<p className="text-gray-800">
								Any interaction via the WhatsApp account associated with the
								User's Registered Mobile Number, following successful OTP-based
								authentication as described above, shall be deemed to have been
								made by the User for that Consent Journey. Finvu shall be
								entitled to rely on such authenticated interactions, and may, at
								its discretion, apply additional authentication measures where
								required for security or regulatory compliance.
							</p>

							{/* Section 5 */}
							<h3 className="mb-5 mt-6">
								5. Consent Journey Initiation, Confirmation and Revocation via
								Finvu's WhatsApp-SDK-based AA Customer Interface
							</h3>

							<p className="text-gray-800">
								<b>Initiation:</b>
							</p>
							<p className="text-gray-800">
								A Consent Journey is initiated when an FIU submits a consent
								request to Finvu via the ReBIT-prescribed /Consent API,
								following which the FIU sends a business-initiated message to
								the User via the FIU's WhatsApp Business Account (WABA),
								containing a CTA redirecting the User to Finvu's WABA. The User
								taps such CTA and sends a request to Finvu to commence the
								consent journey via WhatsApp Flows.
							</p>

							<p className="text-gray-800 mt-4">
								<b>Role of WhatsApp Flows interactions:</b>
							</p>
							<p className="text-gray-800">
								All consent management interactions within the
								WhatsApp-SDK-based AA Customer Interface are conducted via
								WhatsApp Flows — structured, encrypted interactive screens
								presented within the WhatsApp native application. Any User
								action within a WhatsApp Flow constitutes an instruction to
								Finvu to process the corresponding action on Finvu's secure AA
								systems, and does not itself constitute the consent artefact.
								The binding record of the User's consent shall at all times be
								the digitally signed consent artefact as generated, stored, and
								maintained in Finvu's core AA systems in accordance with the
								ReBIT NBFC-AA API Specification.
							</p>

							<p className="text-gray-800 mt-4">
								<b>Confirmation:</b>
							</p>
							<p className="text-gray-800">
								Upon completion of the Consent Journey, Finvu shall send the
								User a completion message via the WhatsApp-SDK-based AA Customer
								Interface confirming the outcome of the journey, being either:
							</p>
							<p className="text-gray-800 ml-4">
								(a) <b>Consent request approved</b> — in which case the
								completion message shall include: (i) a web URL enabling the
								User to initiate revocation of the consent artefact at any time;
								and (ii) a CTA with an embedded URL redirecting the User to the
								FIU's designated platform or interface; or
							</p>
							<p className="text-gray-800 ml-4">
								(b) <b>Consent request rejected</b> — in which case the
								completion message shall confirm that no consent artefact has
								been created.
							</p>
							<p className="text-gray-800">
								The absence of, or any delay in, delivery of the WhatsApp
								completion message due to technical, network, or operational
								reasons shall not, by itself, affect the validity or status of
								the consent artefact as recorded in Finvu's core AA systems.
							</p>

							<p className="text-gray-800 mt-4">
								<b>Revocation:</b>
							</p>
							<p className="text-gray-800 ml-4">
								(a) All consent artefacts created through the
								WhatsApp-SDK-based AA Customer Interface are revocable at any
								time by the User, in accordance with RBI Master Direction on
								NBFC-AA and the ReBIT /Consent/revoke API workflow. The User
								may initiate revocation by clicking the revocation web URL
								provided in the completion message, or through any other
								revocation mechanism made available by Finvu.
							</p>
							<p className="text-gray-800 ml-4">
								(b) Finvu shall require appropriate authentication before
								processing a revocation request. A revocation request shall be
								effective only once it has been validated, processed via the
								/Consent/revoke API, and recorded by Finvu in its core AA
								systems, following which a fresh consent artefact shall be
								required for any further Financial Information sharing, in
								accordance with RBI Master Direction NBFC-AA, Clause 6.6.
							</p>
							<p className="text-gray-800 ml-4">
								(c) For the avoidance of doubt, consent artefacts cannot be
								modified once created. Any change to the parameters of an
								existing consent artefact (including but not limited to purpose,
								data range, frequency, or FIP or FIU scope) requires the User
								to revoke the existing consent artefact and for the FIU to
								submit a fresh consent request, which the User may then approve
								or reject through the prescribed Consent Journey.
							</p>
							<p className="text-gray-800">
								In case of inconsistency between: (i) WhatsApp chat transcripts
								or WhatsApp Flows interaction logs; and (ii) the consent
								artefact and associated logs as stored in Finvu's core AA
								systems, the latter shall prevail as the final and binding
								record of the User's consent artefact.
							</p>

							{/* Section 6 */}
							<h3 className="mb-5 mt-6">
								6. Reliance on WhatsApp Infrastructure and Third-Party Platforms
							</h3>

							<p className="text-gray-800">
								The User acknowledges that WhatsApp is an independent,
								third-party application and communications platform, owned and
								operated by entities that are not under the control of Finvu.
								The User's use of WhatsApp is subject exclusively to WhatsApp's
								own terms of service and privacy policy, and Finvu does not
								endorse, control, or assume responsibility for those terms,
								policies, or the functioning of WhatsApp.
							</p>
							<p className="text-gray-800">
								The User understands that the availability, quality, and
								security of the WhatsApp Channel are dependent on multiple third
								parties, including but not limited to:
							</p>
							<p className="text-gray-800 ml-4">
								(a) WhatsApp / Meta Platforms (and their affiliates);
							</p>
							<p className="text-gray-800 ml-4">
								(b) the User's device manufacturer and operating system
								provider; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) the User's telecom/network service provider.
							</p>
							<p className="text-gray-800">
								Finvu does not warrant that messages sent over WhatsApp will be
								delivered in real time, delivered at all, or displayed in a
								particular format or language, nor that any technical feature
								(such as end-to-end encryption, device locking, or backup
								settings) implemented by WhatsApp will function without
								interruption or error.
							</p>
							<p className="text-gray-800">
								Without prejudice to the general limitation of liability and
								disclaimers contained in Finvu's Terms of Service, Finvu shall
								not be liable for any loss, damage, or consequence arising from:
							</p>
							<p className="text-gray-800 ml-4">
								(a) any failure, delay, or distortion in the transmission or
								receipt of WhatsApp messages;
							</p>
							<p className="text-gray-800 ml-4">
								(b) any modification, suspension, or discontinuation of
								WhatsApp services, features, or APIs; or
							</p>
							<p className="text-gray-800 ml-4">
								(c) any act or omission of WhatsApp / Meta or any network or
								device provider.
							</p>

							{/* Section 7 */}
							<h3 className="mb-5 mt-6">
								7. Data Privacy, Message Content, Retention and Metadata
							</h3>

							<p className="text-gray-800">
								The User acknowledges that:
							</p>
							<p className="text-gray-800 ml-4">
								(a) the content of WhatsApp Interactions (including message
								text, templates, buttons, and time stamps) will be processed and
								stored by WhatsApp / Meta on infrastructure and servers that are
								outside Finvu's control; and
							</p>
							<p className="text-gray-800 ml-4">
								(b) Finvu may receive from WhatsApp and store limited message
								content and metadata (including phone number, message type, time
								stamp, delivery/read status, and identifiers) for the purposes
								set out in these WhatsApp-SDK-based AA Customer Interface T&Cs,
								Finvu's Terms of Service, and in accordance with applicable data
								protection laws in India.
							</p>
							<p className="text-gray-800">
								Finvu will not, through the WhatsApp Channel, request or
								intentionally transmit any detailed financial information such as
								account statements, transaction lists, or other financial data
								flows between FIPs and FIUs. Any such financial information
								continues to be exchanged directly between FIPs and FIUs through
								secure channels mandated by the Account Aggregator framework and
								does not traverse the WhatsApp Channel.
							</p>
							<p className="text-gray-800">
								To the extent that WhatsApp Interactions contain personal data
								of the User, Finvu will process such personal data only:
							</p>
							<p className="text-gray-800 ml-4">
								(a) for the purposes of providing and operating the
								WhatsApp-SDK-based AA Customer Interface;
							</p>
							<p className="text-gray-800 ml-4">
								(b) to comply with applicable legal and regulatory requirements,
								including requirements relating to auditability and traceability
								of consent artefacts; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) in accordance with the data protection and privacy
								provisions of Finvu's Terms of Service and Finvu's then-current
								privacy notices.
							</p>
							<p className="text-gray-800">
								Finvu may retain WhatsApp message logs and related metadata for
								such periods as are reasonably necessary to:
							</p>
							<p className="text-gray-800 ml-4">
								(a) provide and support the WhatsApp-SDK-based AA Customer
								Interface;
							</p>
							<p className="text-gray-800 ml-4">
								(b) maintain evidence of consent request initiation, status, and
								revocation for regulatory and audit purposes; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) comply with legal obligations and internal risk and fraud
								management policies.
							</p>
							<p className="text-gray-800">
								The User understands that, notwithstanding any security measures
								implemented by Finvu, the storage and processing of WhatsApp
								messages and metadata on WhatsApp's infrastructure may be
								subject to risks of unauthorised access, use, or disclosure
								beyond Finvu's reasonable control. The User agrees that Finvu
								shall not be responsible for any compromise of personal data to
								the extent attributable to WhatsApp's own systems, policies, or
								security posture.
							</p>

							{/* Section 8 */}
							<h3 className="mb-5 mt-6">
								8. Security Limitations, Impersonation Risks and User
								Responsibilities
							</h3>

							<p className="text-gray-800">
								The User acknowledges that WhatsApp is a consumer messaging
								application and is not designed as a regulated banking or
								financial transaction platform, and that using WhatsApp for
								consent request-related communications may carry inherent
								security and fraud risks, including but not limited to:
							</p>
							<p className="text-gray-800 ml-4">
								(a) SIM swap, SIM loss, or re-issuance without the User's
								knowledge;
							</p>
							<p className="text-gray-800 ml-4">
								(b) unauthorised access to the User's device (e.g., due to
								loss, theft, malware, or unattended access);
							</p>
							<p className="text-gray-800 ml-4">
								(c) misuse of WhatsApp web/desktop sessions or multi-device
								logins;
							</p>
							<p className="text-gray-800 ml-4">
								(d) message interception, spoofing, or manipulation by third
								parties; and
							</p>
							<p className="text-gray-800 ml-4">
								(e) phishing or social engineering attacks wherein fraudsters
								impersonate Finvu or other entities using look-alike profiles or
								messages.
							</p>
							<p className="text-gray-800">
								The User shall:
							</p>
							<p className="text-gray-800 ml-4">
								(a) maintain exclusive control over and secure possession of the
								SIM card and device associated with the Registered Mobile
								Number;
							</p>
							<p className="text-gray-800 ml-4">
								(b) use appropriate device-level security measures (such as
								PINs, passwords, biometrics, and screen locks) and keep such
								credentials confidential;
							</p>
							<p className="text-gray-800 ml-4">
								(c) ensure that WhatsApp web/desktop sessions are accessed only
								on trusted devices and are promptly logged out after use;
							</p>
							<p className="text-gray-800 ml-4">
								(d) immediately inform the relevant telecom operator and take
								necessary steps if the SIM is lost, stolen, or compromised; and
							</p>
							<p className="text-gray-800 ml-4">
								(e) promptly notify Finvu, through the channels specified in
								Finvu's Terms of Service, if the User suspects that any
								WhatsApp messages purporting to be from Finvu are fraudulent, or
								that the User's WhatsApp account or device has been compromised.
							</p>
							<p className="text-gray-800">
								Any WhatsApp Interaction received by Finvu from the WhatsApp
								account linked to the Registered Mobile Number shall, until
								Finvu is notified and has had a reasonable time to act upon such
								notification, be deemed to have been made by the User or on the
								User's behalf, and Finvu shall be entitled to rely and act upon
								the same.
							</p>
							<p className="text-gray-800">
								The User shall not, through WhatsApp Interactions with Finvu:
							</p>
							<p className="text-gray-800 ml-4">
								(a) send any obscene, illegal, defamatory, or otherwise
								prohibited content; or
							</p>
							<p className="text-gray-800 ml-4">
								(b) attempt to introduce malware, malicious code, or any other
								harmful content.
							</p>
							<p className="text-gray-800">
								Without prejudice to the general indemnity in Finvu's Terms of
								Service, the User shall be responsible for, and shall indemnify
								and hold harmless Finvu from and against, any losses, claims, or
								liabilities arising out of or in connection with any misuse of
								the WhatsApp Channel caused by or attributable to the User's
								failure to comply with this clause 8.
							</p>

							{/* Section 9 */}
							<h3 className="mb-5 mt-6">
								9. Service Availability, Delivery Failures and Channel
								Limitations
							</h3>

							<p className="text-gray-800">
								The WhatsApp-SDK-based AA Customer Interface is offered on a
								best-effort basis. Finvu does not guarantee uninterrupted
								availability of the WhatsApp Channel and may, at its discretion,
								suspend, modify, limit, or discontinue any or all WhatsApp-based
								features at any time, with or without notice, including for
								security, operational, or regulatory reasons.
							</p>
							<p className="text-gray-800">
								The User understands that:
							</p>
							<p className="text-gray-800 ml-4">
								(a) delivery of WhatsApp messages is subject to network
								availability, device configuration, and WhatsApp's own service
								availability;
							</p>
							<p className="text-gray-800 ml-4">
								(b) messages may be delayed, not delivered, delivered in
								duplicate, or delivered out of sequence; and
							</p>
							<p className="text-gray-800 ml-4">
								(c) certain messages may not be displayed correctly on the
								User's device.
							</p>
							<p className="text-gray-800">
								Any failure to receive, or any delay in receiving, a WhatsApp
								notification shall not, in itself, affect:
							</p>
							<p className="text-gray-800 ml-4">
								(a) the validity or enforceability of any consent artefact
								created or revoked through other channels; or
							</p>
							<p className="text-gray-800 ml-4">
								(b) the operation of any time-bound actions or expiry as defined
								in the consent artefact and Finvu's Terms of Service.
							</p>
							<p className="text-gray-800">
								In case of any doubts about the status of a consent artefact or
								the validity of a consent artefact instruction purportedly given
								via WhatsApp, the User shall contact Finvu through the channels
								specified in Finvu's Terms of Service. Records maintained in
								Finvu's core AA systems shall be conclusive in this regard.
							</p>
							<p className="text-gray-800">
								Finvu shall not be liable for any loss, damage, or consequence
								arising from the User's reliance solely on WhatsApp message
								delivery reports, "last seen" indicators, or other
								WhatsApp-specific user interface elements.
							</p>

							{/* Section 10 */}
							<h3 className="mb-5 mt-6">
								10. Regulatory Alignment and Applicable Law (Channel-Specific
								Clarifications)
							</h3>

							<p className="text-gray-800">
								The WhatsApp-SDK-based AA Customer Interface is designed to
								operate within, and not to dilute or modify, the requirements of
								the regulatory framework applicable to Account Aggregators in
								India, including directions issued by the Reserve Bank of India
								from time to time relating to consent architecture, consent
								artefacts, and the secure flow of financial information.
							</p>
							<p className="text-gray-800">
								Nothing in these WhatsApp-SDK-based AA Customer Interface T&Cs
								shall be construed as permitting Finvu to retrieve, share, or
								transfer any financial information of the User without explicit,
								valid, and auditable consent artefact as required under
								applicable regulations. The creation, content, and use of the
								consent artefact shall continue to be governed by Finvu's Terms
								of Service and applicable law.
							</p>
							<p className="text-gray-800">
								To the extent that the processing of personal data through
								WhatsApp Interactions involves "digital personal data" of the
								User, Finvu shall process such data in compliance with
								applicable Indian data protection laws, subject always to the
								limitations and third-party dependencies described in these
								WhatsApp-SDK-based AA Customer Interface T&Cs.
							</p>
							<p className="text-gray-800">
								The governing law and jurisdiction provisions contained in
								Finvu's Terms of Service shall apply equally to any disputes
								arising out of or in connection with the WhatsApp-SDK-based AA
								Customer Interface.
							</p>

							{/* Section 11 */}
							<h3 className="mb-5 mt-6">
								11. Limitation of Liability Specific to the WhatsApp Channel
							</h3>

							<p className="text-gray-800">
								Without prejudice to, and in addition to, the limitation of
								liability and exclusion of warranties contained in Finvu's Terms
								of Service, Finvu shall not be liable for any direct, indirect,
								incidental, consequential, special, punitive, or exemplary
								damages arising out of or related to:
							</p>
							<p className="text-gray-800 ml-4">
								(a) the User's use or inability to use the WhatsApp Channel;
							</p>
							<p className="text-gray-800 ml-4">
								(b) any act, omission, or failure of WhatsApp / Meta or of any
								telecom operator, device manufacturer, or other third party;
							</p>
							<p className="text-gray-800 ml-4">
								(c) any security incident, fraud, or impersonation arising from
								compromise of the User's device, SIM, or WhatsApp account; or
							</p>
							<p className="text-gray-800 ml-4">
								(d) any reliance placed by the User on WhatsApp messages in
								contravention of these WhatsApp-SDK-based AA Customer Interface
								T&Cs or Finvu's Terms of Service.
							</p>
							<p className="text-gray-800">
								In no event shall any channel-specific representations, if any,
								made through WhatsApp be construed as expanding Finvu's
								liability beyond that agreed under Finvu's Terms of Service.
							</p>

							{/* Section 12 */}
							<h3 className="mb-5 mt-6">
								12. Modification, Suspension and Deactivation of WhatsApp
								Channel
							</h3>

							<p className="text-gray-800">
								Finvu may, at its sole discretion and at any time, without prior
								notice to the User:
							</p>
							<p className="text-gray-800 ml-4">
								(a) change the Finvu WhatsApp Number;
							</p>
							<p className="text-gray-800 ml-4">
								(b) add, modify, or discontinue any feature of the
								WhatsApp-SDK-based AA Customer Interface; or
							</p>
							<p className="text-gray-800 ml-4">
								(c) temporarily or permanently suspend or deactivate the
								WhatsApp Channel for any User or for all Users, including for
								reasons of security, fraud, or regulatory direction.
							</p>
							<p className="text-gray-800">
								Any modification to these WhatsApp-SDK-based AA Customer
								Interface T&Cs shall be effective upon publication on Finvu's
								website and/or such other mode as Finvu may determine. The
								User's continued use of the WhatsApp Channel after such
								publication shall constitute deemed acceptance of the modified
								terms.
							</p>
							<p className="text-gray-800">
								The User may opt out of receiving WhatsApp-based communications
								from Finvu by following such deactivation or opt-out procedures
								as may be specified by Finvu from time to time (which may
								include sending specific keywords on WhatsApp). However, such an
								opt-out will not:
							</p>
							<p className="text-gray-800 ml-4">
								(a) affect the validity of any existing consent artefact; or
							</p>
							<p className="text-gray-800 ml-4">
								(b) prevent Finvu from using other channels (such as SMS, email,
								or in-app notifications) as permitted under Finvu's Terms of
								Service and applicable law.
							</p>

							{/* Section 13 */}
							<h3 className="mb-5 mt-6">13. Miscellaneous</h3>

							<p className="text-gray-800">
								These WhatsApp-SDK-based AA Customer Interface T&Cs form an
								integral part of the overall contractual framework between the
								User and Finvu in respect of AA services. They are intended
								solely to address incremental risks, processes, and obligations
								arising from the use of WhatsApp as a communication and consent
								journey channel, and shall not be interpreted to reduce or
								dilute any protections, limitations, or obligations set out in
								Finvu's Terms of Service.
							</p>
							<p className="text-gray-800">
								If any provision of these WhatsApp-SDK-based AA Customer
								Interface T&Cs is held to be invalid, illegal, or unenforceable,
								the remaining provisions shall continue in full force and effect.
							</p>
							<p className="text-gray-800">
								Any reference in Finvu's Terms of Service to "channels",
								"digital interfaces", or similar terms for the purpose of
								providing consent journeys or consent-related communications
								shall be deemed to include the WhatsApp Channel, to the extent
								enabled by Finvu in accordance with these WhatsApp-SDK-based AA
								Customer Interface T&Cs.
							</p>
							<p className="text-gray-800">
								The User confirms that it is aware that the WhatsApp-SDK-based
								AA Customer Interface is optional and that the User may use
								alternative consent channels made available by Finvu (such as
								voice, web or mobile app journeys) without prejudice to the
								User's rights under Finvu's Terms of Service.
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default WhatsappTerms;
